"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var push_notifications_service_1 = require("./push-notifications/services/push-notifications.service");
__export(require("./push-notifications/services/push-notifications.service"));
var PushNotificationsModule = (function () {
    function PushNotificationsModule() {
    }
    return PushNotificationsModule;
}());
PushNotificationsModule.decorators = [
    { type: core_1.NgModule, args: [{
                providers: [push_notifications_service_1.PushNotificationsService],
                exports: []
            },] },
];
/** @nocollapse */
PushNotificationsModule.ctorParameters = function () { return []; };
exports.PushNotificationsModule = PushNotificationsModule;
//# sourceMappingURL=push-notifications.module.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/angular2-notifications/dist/src/push-notifications.module.js
// module id = ../../../../angular2-notifications/dist/src/push-notifications.module.js
// module chunks = 3